module.exports = __webpack_public_path__ + "static/assets/7a464c190580fe09920f056945fd1fd8.png";